/**
 * MODULE: _shared/frontend-shell/src/config.ts
 * PURPOSE: Eager validation of API base URL on prod bundle load; re-exports shared API config.
 * DEPENDENCIES: @shared/lib/frontend/api/config (getApiBaseUrl, API_CONFIG), workspaceSessionHandoff
 * PUBLIC API: appConfig, API_CONFIG, getApiBaseUrl (re-export)
 * SIDE EFFECTS: Consumes Agentic→Traditional session handoff; PROD getApiBaseUrl() once at module load
 * AGENT SAFETY: 🟡 RESTRICTED
 * FILE SIZE: 40 / 100
 * RECENT: 2026-07-30 [2.2.1844] — Consume workspace session handoff before AuthProvider
 * RECENT_PRIOR: 2026-03-26 [2.2.197] - Loaded from main.tsx before App; Docker nginx injects /config.js via entrypoint.sh.
 */

import { API_CONFIG, getApiBaseUrl } from '@shared/lib/frontend/api/config';
import { consumeWorkspaceSessionHandoff } from '../../lib/frontend/api/workspaceSessionHandoff';

export { API_CONFIG, getApiBaseUrl };

/** Apply Agentic → Traditional JWT handoff before AuthProvider reads localStorage. */
consumeWorkspaceSessionHandoff();

export const appConfig = {
  get apiBaseUrl(): string {
    return getApiBaseUrl();
  },
};

if (import.meta.env.PROD) {
  void getApiBaseUrl();
}
